(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function (event) {
    var swiper = new Swiper('.heroSwiper', {
      direction: 'horizontal',
      loop: true,
      speed: 900,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
(function () {

  const STORAGE_KEY = 'shopify_wishlist';

  const grid = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');
  const loading = document.getElementById('wishlist-loading');
  const countText = document.getElementById('wishlist-count-text');

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function updateHeaderWishlistCount(count) {
    document.querySelectorAll('.wishlist-count-text').forEach((el) => {
      el.textContent = count > 99 ? '99+' : count;
    });
    document.querySelectorAll('.wishlist-count-bubble').forEach((el) => {
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    if (window.wishlistInstance && typeof window.wishlistInstance.refresh === 'function') {
      window.wishlistInstance.refresh();
    }
    updateHeaderWishlistCount(items.length);
  }

  function removeItem(id) {
    const items = getWishlist().filter(i => String(i.id) !== String(id));
    saveWishlist(items);
    renderWishlist();
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function money(cents) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  function productCard(product, item) {
    const v = product.variants[0];
    const hasCompare = v.compare_at_price > v.price;

    const div = document.createElement('div');
    div.className = 'wishlist-item';
    div.innerHTML = `
      <div class="wishlist-item__media">
        <a href="/products/${product.handle}">
          <img src="${product.featured_image}" alt="${product.title}">
        </a>
        <button class="wishlist-item__remove" data-remove="${item.id}">
          <svg viewBox="0 0 24 24" fill="none" stroke-width="2">
            <path d="M6 6l12 12M6 18L18 6"/>
          </svg>
        </button>
      </div>
      <div class="wishlist-item__info">
        <div class="wishlist-item__title">
          <a href="/products/${product.handle}">${product.title}</a>
        </div>
        <div class="wishlist-item__price">
          ${money(v.price)}
          ${hasCompare ? `<span class="wishlist-item__price-compare">${money(v.compare_at_price)}</span>` : ''}
        </div>
        <a href="/products/${product.handle}" class="wishlist-item__view-product">View Product</a>
      </div>
    `;
    return div;
  }

  async function renderWishlist() {
    const items = getWishlist();

    loading.style.display = 'none';
    updateHeaderWishlistCount(items.length);

    if (!items.length) {
      empty.style.display = 'block';
      grid.style.display = 'none';
      countText.textContent = '0 items';
      return;
    }

    countText.textContent = `${items.length} item(s)`;
    grid.innerHTML = '';
    grid.style.display = 'grid';

    for (const item of items) {
      if (!item.handle) continue;
      const product = await fetchProduct(item.handle);
      if (!product) continue;
      grid.appendChild(productCard(product, item));
    }

    if (!grid.children.length) {
      empty.style.display = 'block';
      grid.style.display = 'none';
    }
  }

  grid.addEventListener('click', e => {
    const btn = e.target.closest('[data-remove]');
    if (btn) removeItem(btn.dataset.remove);
  });

  renderWishlist();

})();

  } catch(e) { console.error(e); }
})();
})();
